export const SITEKEY = '6Le1aqkUAAAAAAPsov0VYB2-9L5xrsfyJJ9FnoYA';
export const ERROR_NOTIFICATION_KEY = 'ERROR_NOTIFICATION';